import { getWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
import { Product } from "./product";
import { Project } from "./project";
import { Structure } from "./structure";
import { Supply_chain } from "./supply_chain";

const archived = apiUrl + "/archived";
const routes = {
  label: "Archived",
  root: archived,
  get_by_my_company: archived + "/get_by_my_company",
};

export const Archived = {
  label: routes.label,
  get_by_my_company: () => getWithToken(routes.get_by_my_company),
  /**
   *
   * @param {[{type: "product" | "project", product_id: string | null, project_id: string | null}]} items
   */
  unarchive: (items) => {
    const productIds = items
      .filter((i) => i.type === "product")
      .map((i) => i.product_id)
      .filter(Boolean);
    const projectIds = items
      .filter((i) => i.type === "project")
      .map((i) => i.project_id)
      .filter(Boolean);
    const supplyChainIds = items
      .filter((i) => i.type === "supply_chain")
      .map((i) => i.supply_chain_id)
      .filter(Boolean);
    const structureIds = items
      .filter((i) => i.type === "structure")
      .map((i) => i.structure_id)
      .filter(Boolean);
    const jobs = [];
    if (productIds.length > 0) jobs.push({ key: "product", promise: Product.unarchive(productIds) });
    if (projectIds.length > 0) jobs.push({ key: "project", promise: Project.unarchive(projectIds) });
    if (supplyChainIds.length > 0) jobs.push({ key: "supply_chain", promise: Supply_chain.unarchive(supplyChainIds) });
    if (structureIds.length > 0) jobs.push({ key: "structure", promise: Structure.unarchive(structureIds) });
    if (jobs.length === 0) return Promise.resolve([]);
    return Promise.all(jobs.map((j) => j.promise));
  },
  /**
   *
   * @param {[{type: "product" | "project", product_id: string | null, project_id: string | null}]} items
   * @returns
   */
  delete: (items) => {
    const productIds = items
      .filter((i) => i.type === "product")
      .map((i) => i.product_id)
      .filter(Boolean);
    const projectIds = items
      .filter((i) => i.type === "project")
      .map((i) => i.project_id)
      .filter(Boolean);
    const supplyChainIds = items
      .filter((i) => i.type === "supply_chain")
      .map((i) => i.supply_chain_id)
      .filter(Boolean);
    const structureIds = items
      .filter((i) => i.type === "structure")
      .map((i) => i.structure_id)
      .filter(Boolean);
    const jobs = [];
    if (productIds.length > 0) jobs.push({ key: "product", promise: Product.delete(productIds) });
    if (projectIds.length > 0) jobs.push({ key: "project", promise: Project.delete(projectIds) });
    if (supplyChainIds.length > 0) jobs.push({ key: "supply_chain", promise: Supply_chain.delete(supplyChainIds) });
    if (structureIds.length > 0) jobs.push({ key: "structure", promise: Structure.delete(structureIds) });
    if (jobs.length === 0) return Promise.resolve([]);
    return Promise.all(jobs.map((j) => j.promise));
  },
};
